let apiUrl = process.env.FEED_API_URL || 'http://localhost:1234';
let portalUrl = process.env.PORTAL_URL || 'http://localhost:1234';

if (process.env.DEBUG_PILET) {
  apiUrl = 'http://localhost:1234';
  portalUrl = 'http://localhost:1234';
}

export { apiUrl, portalUrl };
